import { styled } from '@classify/react-core-components/styles';
import Box from '@classify/react-core-components/Box';

const BaseBlock = styled(Box)(({ theme: { spacing, palette, breakpoints, radius } }) => ({
  borderRadius: radius?.banner || 4,
  border: `solid 1px ${palette.layout.surface.border}`,
  padding: spacing(2),
  background: palette.layout.surface.alternativeBackground,

  [breakpoints.up('md')]: {
    padding: spacing(3, 4),
  },
}));

export default BaseBlock;
